"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadAction = exports.requestActions = exports.requestActionTypes = exports.actionTypes = void 0;

var _fluxActions = require("flux-actions");

var _actions = require("settings-ui-sdk/utils/actions");

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-sdk/utils/namespacedKeyMirror"));

var actionTypes = (0, _namespacedKeyMirror.default)({
  LOAD: null,
  FETCH: null
}, 'hub-users');
exports.actionTypes = actionTypes;
var requestActionTypes = (0, _actions.createRequestTypes)(actionTypes.FETCH);
exports.requestActionTypes = requestActionTypes;
var requestActions = (0, _actions.createRequestActions)(requestActionTypes);
exports.requestActions = requestActions;
var loadAction = (0, _fluxActions.createAction)(actionTypes.LOAD);
exports.loadAction = loadAction;